<template>
  <section class="text-gray-600 body-font bg-section mt-24">
    <div class="container py-24 mx-auto">
      <div class="text-center mb-20">
        <p class="text-base leading-relaxed xl:w-2/4 lg:w-3/4 mx-auto text font-bold">
          ~~ Delivery Process ~~
        </p>
        <h1 class="sm:text-4xl text-2xl font-bold title-font text-black mb-4">
          OUR DELIVERY PROCESS
        </h1>
      </div>
      <div class="flex flex-wrap justify-around md:justify-center">
        <div class="lg:w-1/4 w-5/6 lg:mb-0 mb-6 p-4">
          <div class="h-full text-center">
            <div
              class="icon-bg w-60 h-60 inline-flex items-center justify-center rounded-full bg-white icon mb-5 flex-shrink-0">
              <i class="fa fa-home align-center flex justify-center" aria-hidden="true"></i>

              <svg class="w-24 h-24 " aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="m4 12 8-8 8 8M6 10.5V19a1 1 0 0 0 1 1h3v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h3a1 1 0 0 0 1-1v-8.5" />
              </svg>
            </div>

            <h2 class="text-grey-900 font-extrabold  title-font tracking-wider text-lg">
              01.
            </h2>
            <p class="leading-relaxed text-lg font-bold">Connect to nearest farm</p>
          </div>
        </div>

        <div class="lg:w-1/4 w-5/6 lg:mb-0 mb-6 p-4">
          <div class="h-full text-center">
            <div
              class="icon-bg w-60 h-60 inline-flex items-center justify-center rounded-full bg-white icon mb-5 flex-shrink-0">
              <svg class="w-24 h-24 " aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                fill="currentColor" viewBox="0 0 24 24">
                <path fill-rule="evenodd"
                  d="M14 7h-4v3a1 1 0 0 1-2 0V7H6a1 1 0 0 0-.997.923l-.917 11.924A2 2 0 0 0 6.08 22h11.84a2 2 0 0 0 1.994-2.153l-.917-11.924A1 1 0 0 0 18 7h-2v3a1 1 0 1 1-2 0V7Zm-2-3a2 2 0 0 0-2 2v1H8V6a4 4 0 0 1 8 0v1h-2V6a2 2 0 0 0-2-2Z"
                  clip-rule="evenodd" />
              </svg>
            </div>
            <h2 class="text-grey-900 font-extrabold  title-font tracking-wider text-lg">
              02.
            </h2>
            <p class="leading-relaxed text-lg font-bold">Place your order</p>
          </div>
        </div>
        <div class="lg:w-1/4 w-5/6 lg:mb-0 mb-6 p-4 md:mx-auto">
          <div class="h-full text-center">
            <div
              class="icon-bg w-60 h-60 inline-flex items-center justify-center rounded-full bg-white icon mb-5 flex-shrink-0">
              <svg class="w-24 h-24" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                fill="currentColor" viewBox="0 0 24 24">
                <path fill-rule="evenodd"
                  d="M11.906 1.994a8.002 8.002 0 0 1 8.09 8.421 7.996 7.996 0 0 1-1.297 3.957.996.996 0 0 1-.133.204l-.108.129c-.178.243-.37.477-.573.699l-5.112 6.224a1 1 0 0 1-1.545 0L5.982 15.26l-.002-.002a18.146 18.146 0 0 1-.309-.38l-.133-.163a.999.999 0 0 1-.13-.202 7.995 7.995 0 0 1 6.498-12.518ZM15 9.997a3 3 0 1 1-5.999 0 3 3 0 0 1 5.999 0Z"
                  clip-rule="evenodd" />
              </svg>
            </div>
            <h2 class="text-grey-900 font-extrabold  title-font tracking-wider text-lg">
              03.
            </h2>
            <p class="leading-relaxed text-lg font-bold">Choose location</p>
          </div>
        </div>
        <div class="lg:w-1/4 w-5/6 lg:mb-0 p-4 md:mx-auto">
          <div class="h-full text-center">
            <div
              class="icon-bg w-60 h-60 inline-flex items-center justify-center rounded-full bg-white icon mb-5 flex-shrink-0">

              <svg class="w-24 h-24" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M13 7h6l2 4m-8-4v8m0-8V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v9h2m8 0H9m4 0h2m4 0h2v-4m0 0h-5m3.5 5.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm-10 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z" />
              </svg>
            </div>
            <h2 class="text-grey-900 font-extrabold  title-font tracking-wider text-lg">
              04.
            </h2>
            <p class="leading-relaxed text-lg font-bold">Delivery time</p>
          </div>
        </div>
      </div>
      <div class="flex justify-center align-center lg:mt-12">
        <a href=""
          class="inline-flex text-white btn border-0 py-4 px-4 md:px-8 focus:outline-none text-lg rounded-lg ">Shop
          Now</a>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "DeliveryProcess",
};
</script>
<style scoped>

.icon {
  color: #3d9421;
  font-size: 3rem;
}

.icon-bg:hover {
  background-color: #3d9421;
  font-size: 2rem;
  color: #ffff;
  border: 15px solid #edeeef;
  transition: all 1.3s;
}

.icon-bg {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2), 0 2px 4px rgba(0, 0, 0, 0.15), 0 8px 16px rgba(0, 0, 0, 0.1), 0 16px 32px rgba(0, 0, 0, 0.05);
}

.btn {
  background-color: #3d9421;
}
</style>